/**
 * Webhook Reference route — redirects to Webhook Events guide (content merged).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/docs/webhooks")({
	beforeLoad: () => {
		throw redirect({ to: "/docs/webhooks-guide" });
	},
});
